var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['es-loading', {'open': _vm.show}],on:{"click":function($event){return _vm.toggle()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"es image"},[_c('img',{attrs:{"src":require("../assets/loading.gif")}})])
}]

export { render, staticRenderFns }